import Immutable from 'immutable';

// constants
import {
  APPOINTMENT_CANCEL,
  APPOINTMENT_CLOSE,
  APPOINTMENT_CONFIRM,
  APPOINTMENT_CREATE,
  APPOINTMENT_LIST_CLEAR,
  APPOINTMENT_LIST_FETCH, APPOINTMENT_OPEN, APPOINTMENT_SHOW,
  APPOINTMENT_UPDATE
} from '../constants/appointmentTypes';
import { FREE_STANDING_APPOINTMENT_CREATE, FREE_STANDING_APPOINTMENT_ERROR_CLEAR } from '../constants/freeStandingAppointmentTypes';

// lib
import httpReducer from '../lib/httpReducer';

const groupByDate = function(map, action) {
  const payload       = action.payload || {};
  const normalized    = payload.normalized || {};
  const entities      = normalized.entities || {};
  const entity        = Immutable.fromJS(entities.appointment || {});
  const groupedItems  = entity.groupBy((item) => item.get('scheduledOn'))
    .sort((valueA, valueB) => valueB.first().get('from') - valueA.first().get('from'))
    .map((list) => list.sortBy((item) => item.get('from')));

  let newMap = map;

  newMap = newMap.set('result', normalized.result || Immutable.List());

  if (groupedItems.size > 0) {
    const oldData = newMap.get('data') || Immutable.Map();
    const newData = oldData.merge(groupedItems);

    newMap = newMap.set('data', newData);
  }

  if (payload.start_date && payload.end_date) {
    newMap = newMap.withMutations((m) => {
      m.set('start_date', payload.start_date);
      m.set('end_date', payload.end_date);
    });
  }

  return newMap;
};

const replace = function(map, action) {
  const data        = map.get('data') || Immutable.Map();
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities.appointment || {};
  const appointment = entity[normalized.result];

  let newData = data;

  if (appointment) {
    const group     = newData.get(appointment.scheduledOn);

    if (group) {
      const newGroup  = group.set(appointment.id, Immutable.fromJS(appointment));

      newData = newData.set(appointment.scheduledOn, newGroup);
    }
  }
  return map.set('data', newData);
};

const cancel = function(map, action) {
  const data        = map.get('data') || Immutable.Map();
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities.appointment || {};
  const appointment = entity[normalized.result];
  let newData = data;

  if (appointment) {
    const group     = newData.get(appointment.scheduledOn);

    if (group) {
      const newGroup  = group.set(appointment.id, Immutable.fromJS(appointment));
      const sortedGroup = newGroup.sortBy((item) => item.get('from'));

      newData = newData.set(appointment.scheduledOn, sortedGroup.filter((item) => {
        const checkIfAppTheSameStart = item.get('from') === action.payload.from;
        const checkIfAppTheSameEnd = item.get('to') === action.payload.to;
        const checkIfConfirmed = item.get('status') === 'confirmed';
        const checkIfBooked =  item.get('status') === 'booked';

        return !(checkIfAppTheSameStart && checkIfAppTheSameEnd && (checkIfConfirmed || checkIfBooked));
      }));
    }
  }

  return map.set('data', newData);
};

const add = function(map, action) {
  const data        = map.get('data') || Immutable.Map();
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities.appointment || {};
  const appointment = entity[normalized.result];
  let newData = data;

  if (appointment) {
    const group     = newData.get(appointment.scheduledOn);

    if (group) {
      const newGroup  = group.set(appointment.id, Immutable.fromJS(appointment));

      newData = newData.set(appointment.scheduledOn, newGroup);
    } else {
      return groupByDate(map, action);
    }
  }

  return map.set('data', newData);
};

const clearError = (state) => {
  return state.set('error', false);
};

const show = function(map, action) {
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities.appointment || {};
  const appointment = entity[normalized.result];
  let data = Immutable.Map();

  if (appointment) {
    const group     = Immutable.Map();
    const newAppointment  = group.set(appointment.id, Immutable.fromJS(appointment));

    data = data.set(appointment.scheduledOn, newAppointment);
  }
  return map.set('data', data);
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case APPOINTMENT_CANCEL:                      return httpReducer(state, action, cancel);
    case APPOINTMENT_CLOSE:                       return httpReducer(state, action, replace);
    case APPOINTMENT_OPEN:                        return httpReducer(state, action, replace);
    case APPOINTMENT_CREATE:                      return httpReducer(state, action, replace);
    case APPOINTMENT_CONFIRM:                     return httpReducer(state, action, replace);
    case APPOINTMENT_LIST_CLEAR:                  return Immutable.Map();
    case APPOINTMENT_LIST_FETCH:                  return httpReducer(state, action, groupByDate);
    case APPOINTMENT_UPDATE:                      return httpReducer(state, action, replace);
    case FREE_STANDING_APPOINTMENT_CREATE:        return httpReducer(state, action, add);
    case FREE_STANDING_APPOINTMENT_ERROR_CLEAR:   return clearError(state);
    case APPOINTMENT_SHOW:                        return httpReducer(state, action, show);
    default:                                      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/appointment.js